export enum OriginEnum {
  citizen = "citizen",
  foreman = "foreman",
}

export interface IDocument {
  id?: string;
  workorderId?: string;
  url?: string;
  type?: string;
  origin: OriginEnum;
  filename?: string;
  description?: string;
  user?: string;
  creationDatetime?: Date;
}
